import { useState } from 'react';

type UseSelectionManagerProps<T> = {
  initialValue?: T | T[];
  isMulti?: boolean;
  onChange?: (val: T | T[]) => void;
};

export const useSelectionManager =<T,>({
    initialValue,
    isMulti = false,
    onChange,
    }: UseSelectionManagerProps<any> & {
    initialValue?: any;
    isMulti?: boolean;
    onChange?: (val: any | any[]) => void;
}) =>{
    const [selected, setSelected] = useState<any>(initialValue ?? (isMulti ? [] : null));

    const handleSelect = (val: T, isMultiSelect: boolean = false, additionalData:any = new Set(), keyVal: string = "") => {
        //additionalData Is Set of Unique Keys,
        //Keyval is a unique key currently clicked element.
        if (isMultiSelect) {
            // const current = selected as T[];
            // const exists = current.includes(val);
            // const newSelection = exists ? current.filter(v => v !== val) : [...current, val];

            let selectedValues = [...selected]

            if (selectedValues.length > 0) {
                if (additionalData.has(keyVal)) {
                    selectedValues.push(val)
                } else {
                    selectedValues = selectedValues.filter((itr) => {
                        return itr.KeyValue !== keyVal
                    })
                }
            } else {
                selectedValues.push(val)
            }

            setSelected(selectedValues);
            onChange?.(selectedValues);
        } else {
            setSelected(val);
            onChange?.(val);
        }
    };
    const clearSelection = () => {
        const cleared = isMulti ? [] : null;
        setSelected(cleared as T | T[]);
        onChange?.(cleared as T | T[]);
    };

    const selectAll = (allOptions: T[]) => {
        if (isMulti) {
            setSelected(allOptions);
            onChange?.(allOptions);
        }
    };

    return {
        selected,
        handleSelect,
        clearSelection,
        selectAll,
      };
}